import { useToggle } from "client/hooks/utils/useToggle";
import { translateFunc } from "client/utils/translateFunc";
import { MoreOptionsIcon } from "components/common/Icons/MoreOptionsIcon";
import { Popup } from "components/common/Popup/Popup";
import { ToolTip } from "components/common/ToolTip/ToolTip";
import { useFindTextBox } from "../useFindTextBox";
import { MoreOptionsContent } from "./MoreOptionsContent/MoreOptionsContent";

export interface MoreOptionsProps {
    textBoxId: string;
}

export const MoreOptions = ({ textBoxId }: MoreOptionsProps) => {
    const { textBox } = useFindTextBox(textBoxId);
    const { isOpen, toggle, onClose: close } = useToggle();
    return (
        <Popup isOpen={isOpen} close={close} content={<MoreOptionsContent textBox={textBox} />}>
            <ToolTip text={translateFunc("more-settings")}>
                <button
                    className={`w-10 h-10 flex items-center justify-center ${
                        isOpen
                            ? "bg-irGray-200 dark:bg-darkSurface-300"
                            : "hover:bg-irGray-100 dark:hover:bg-darkSurface-300"
                    } rounded-lg`}
                    onClick={toggle}
                >
                    <MoreOptionsIcon />
                </button>
            </ToolTip>
        </Popup>
    );
};
